import { createRouter, createWebHistory } from '@ionic/vue-router';
import {  RouteRecordRaw } from 'vue-router';
import { menuController } from '@ionic/vue';
import TabsPage from '../views/tabs/TabsPage.vue';
import { loginMessage, verifyTokenService, /* checkTokenStateService */ } from '@/services/auth.services';
import { START_LOCATION } from 'vue-router';
import { Preferences } from '@capacitor/preferences';
import { resetSessionTimer } from '@/services/session.services';

// const logthaticamehere = async (to: RouteLocationNormalized) => {
//   const isAuthenticated = await verifyTokenService()

//   if (!isAuthenticated) {
//     return {
//       path: '/login', params: { message: to.fullPath }
//     }
//   }
// }

const routes: Array<RouteRecordRaw> = [
  {
    name: 'home',
    path: '/',
    redirect: 'login',
    meta: { requiresAuth: false },

  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {

        path: '',
        redirect: '/tabs/accueil',
        meta: { requiresAuth: false, transition: 'slide-right' },
        //beforeEnter: (to,from) => logthaticamehere(to,from),

      },
      {
        path: 'accueil',
        name: '/tabs/accueil',
        meta: { requiresAuth: false, transition: 'slide-right' },
        //beforeEnter: (to,from) => logthaticamehere(to,from),

        component: () => import('@/views/tabs/TabAccueil.vue'),
      },
      {
        path: 'tickets',
        name: '/tabs/tickets',
        meta: { requiresAuth: false },
        // beforeEnter: (to, from) => logthaticamehere(to, from),
        component: () => import('@/views/tabs/TabTickets.vue')
      },
      {
        path: 'carto',
        name: '/tabs/carto',
        meta: { requiresAuth: false },
        // beforeEnter: (to, from) => logthaticamehere(to, from),

        component: () => import('@/views/tabs/TabCarto.vue')
      },
      {
        path: 'search',
        name: '/tabs/search',
        meta: { requiresAuth: true },
        // beforeEnter: (to, from) => logthaticamehere(to, from),

        component: () => import('@/views/tabs/TabRecherche.vue')
      },
      {
        path: 'profile',
        name: '/tabs/profile',
        meta: { requiresAuth: false },
        //beforeEnter: (to,from) => logthaticamehere(to,from),

        component: () => import('@/views/tabs/TabProfile.vue')
      },
      {
        path: 'audits',
        name: '/tabs/audits',
        meta: { requiresAuth: false },
        //beforeEnter: (to,from) => logthaticamehere(to,from),

        component: () => import('@/views/tabs/TabAudits.vue')
      },
      {
        path: 'ncf',
        name: '/tabs/ncf',
        meta: { requiresAuth: false },
        //beforeEnter: (to,from) => logthaticamehere(to,from),

        component: () => import('@/views/tabs/TabNcf.vue')
      }

    ]
  },

  {
    name: 'mobileframe',
    meta: { requiresAuth: true },
    path: '/mobileframe',
    component: () => import('@/views/manager/ManagerPageFrame.vue'),
  },
  {
    name: 'login',
    meta: { requiresAuth: false },
    path: '/login',
    component: () => import('@/views/LoginPage.vue'),
    props: true
  },
  {
    path: '/status',
    name: 'status',
    meta: { requiresAuth: false },
    component: () => import('@/views/registration/ServerStatusPage.vue')
  },
  // {
  //   name: 'landing',
  //   meta: { requiresAuth: yes },
  //   path: '/landing',
  //   component: () => import('@/views/HomePage.vue'),

  // },
  {
    name: 'manager',
    meta: { requiresAuth: true },
    path: '/manager',
    component: () => import('@/views/manager/ManagerPage.vue'),

  },
  {
    name: 'basemongo',
    meta: { requiresAuth: true },
    path: '/basemongo',
    component: () => import('@/views/BasemongoPage.vue'),
  },
  {
    name: 'register',
    meta: { requiresAuth: true },
    path: '/register',
    component: () => import('@/views/registration/RegisterPage.vue'),

  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


router.beforeEach(async (to, from, next) => {

  if (from === START_LOCATION) {
    //console.log('this fires on page reload only, not every route change');
  }


  //console.log("routed");

  loginMessage.value = ''
  const isAuthenticated = await verifyTokenService();
  //console.log(isAuthenticated);

  menuController.close("mainMenu");


  if (to.matched.some(record => record.meta.requiresAuth)) {
    //console.log("it requires Auth");

    if (!isAuthenticated) {
      // Redirige l'utilisateur vers la page de connexion s'il n'est pas authentifié
      loginMessage.value = 'Jeton de connexion plus valide, vous avez été redirigé vers la page de connexion'

      await resetSessionTimer();

      await Preferences.set({
        key: 'loginMessage',
        value: 'Jeton de connexion plus valide, vous avez été redirigé vers la page de connexion'
      })


      //console.log(loginMessage.value)
      next({ name: 'login' });
    } else {
      // L'utilisateur est authentifié, continue la navigation
      await Preferences.remove({ key: 'loginMessage' });

      next();
    }
  } else {
    // Ne nécessite pas d'authentification, continue la navigation
    
    next();
  }
});



export default router
